module.exports = __webpack_public_path__ + "img/slide-4.26afd13c.png";